import { Players } from '../players'
import { Result } from '../result'
import { CSSTransition } from 'react-transition-group'
import { stageType } from '../constants/stageType'
import { stageSelector, selectedBetSelector } from 'models/battle/selectors'
import { useSelector } from 'react-redux'

import c from './assets/sass/status.module.scss'

export const Status = () => {
    const stage = useSelector(stageSelector)
    const selectedBet = useSelector(selectedBetSelector)

    return (
        <div className={c.component}>
            <CSSTransition
                in={stage !== stageType.finished}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <Players />
            </CSSTransition>
            <CSSTransition
                in={stage === stageType.finished}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <Result selectedBet={selectedBet} />
            </CSSTransition>
        </div>
    )
}
